import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelCheckbox as _vModelCheckbox, withDirectives as _withDirectives, createVNode as _createVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { style: {"display":"flex"} }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("label", { for: "checkbox" }, "Select to add any VAT Loan", -1)
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["onSubmit"]
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", { for: "vat-loan-period" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "header" }, "Period Selection:")
], -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { for: "vat-loan-amount" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "header" }, "VAT Loan amount:")
], -1)
const _hoisted_7 = ["disabled", "title"]

import { computed, ref } from "vue";
import Popup from "../Popup.vue";
import DatePeriod from "@/types/DatePeriod";
import PeriodSelector from "../PeriodSelector.vue";
import TablePersistentChecking from "@/components/TablePersistentChecking.vue";
import { DrawdownHelper } from "@/services/helpers/DrawdownHelper";
import { DrawdownTableItem } from "@/models/Drawdown";
import { CurrencySymbol } from "@/services/helpers/Helper";
import IVatLoanItem from "@/Interfaces/VATLoans/IVatLoan";
import CurrencyInput from "../CurrencyInput.vue";
import { authService } from "@/auth/authSingleton";
import useSpinnerPopup from "@/services/composables/SpinnerPopup";
import useNotifierWithErrFormatter from "@/services/composables/NotifierWithErrFormatter";

const submitHint = "Submit the Vat Loan";



export default /*#__PURE__*/_defineComponent({
  __name: 'DrawdownPopUp',
  props: {
    modelValue: {}
  },
  emits: ["update:modelValue", "confirm"],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emits = __emit;
const drawdown = computed({
    get() {
        return props.modelValue;
    },
    set(val) {
        emits("update:modelValue");
    },
});
const symbol = computed(
    () => `${CurrencySymbol[drawdown.value.Market!] ?? CurrencySymbol.GBP}`
);
const isLoan = ref<boolean>(false);
const rows = ref<IVatLoanItem[]>([]);
const cols: Array<keyof IVatLoanItem> = [
    "Market",
    "DrawdownDate",
    "VatLoanAmount",
    "VatLoanPeriod",
];
const labels: string[] = [
    "Market",
    "Drawdown Date",
    "VAT Loan Amount",
    "VAT Loan Period",
];
const loanAmount = ref<string>();
const loanPeriod = ref<DatePeriod>();
const urlParams = process.env.VUE_APP_CONFIRM_DRAWDOWNS_URL_PARAMS;
const working = computed(() => {
    return isLoan.value && rows.value.length < 1;
});
const workingReason = computed(() => {
    return isLoan.value && rows.value.length < 1
        ? "When loan is selected, you must enter at least one entry before confirming"
        : "";
});
const DrawdownServices: DrawdownHelper = new DrawdownHelper();

function clearEntries() {
    loanPeriod.value = undefined;
    loanAmount.value = undefined;
    isLoan.value = false;
    rows.value = [];
}
function submit() {
    if (!loanPeriod.value || loanPeriod.value.toString() === "NULL") {
        useNotifierWithErrFormatter().warn({
            msg: "Please select loan amount and period",
        });
    } else {
        const newRow: IVatLoanItem = {
            Market: `${drawdown.value!.Market}`,
            DrawdownDate: drawdown.value
                .DrawdownDate!.toLocaleString("sv-SE")
                .split(" ")[0],
            VatLoanAmount: loanAmount.value!,
            VatLoanPeriod: loanPeriod.value!.toString(),
            UserEmail: authService.getEmailAddress(),
        };
        rows.value = [...rows.value, newRow];
        loanAmount.value = undefined;
        loanPeriod.value = new DatePeriod(null);
    }
}
function hasDuplicates() {
    const values = rows.value.map((obj) => obj["VatLoanPeriod"]);
    return new Set(values).size !== values.length;
}
async function ConfirmDrawdown() {
    drawdown.value!.VatLoans = rows.value ? rows.value : [];

    if (hasDuplicates()) {
        useNotifierWithErrFormatter().warn({
            msg: "Duplicate Vat Loan Period entries",
        });
    } else {
        if (working.value) return;
        const closeSpinner = useSpinnerPopup().show();
        try {
            await DrawdownServices.ConfirmDrawdown(urlParams!, drawdown.value);
            useNotifierWithErrFormatter().success({
                msg: "Payment successfully registered.",
            });
            closeChild();
            emits("confirm");
        } catch (error) {
            useNotifierWithErrFormatter().error({
                name: `${__filename}/${ConfirmDrawdown.name}`,
                errorType: "Confirming Drawdown",
                error,
            });
        } finally {
            closeSpinner();
        }
    }
}
function closeChild() {
    clearEntries();
    emits("update:modelValue");
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Popup, {
    style: {"min-width":"60%","min-height":"30%","overflow-y":"scroll"},
    "model-value": !!drawdown.value,
    title: "Drawdown confirmation",
    hasClose: "",
    onClose: closeChild
  }, {
    contents: _withCtx(() => [
      _createElementVNode("div", null, [
        _createTextVNode(" Please confirm you want to proceed for a drawdown of "),
        _createElementVNode("strong", null, _toDisplayString(symbol.value) + _toDisplayString(drawdown.value!.DrawdownAmount), 1),
        _createTextVNode(" on "),
        _createElementVNode("strong", null, _toDisplayString(drawdown.value!.DrawdownDate.toLocaleString("sv-SE").split(" ")[0]) + ":", 1)
      ]),
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        _withDirectives(_createElementVNode("input", {
          type: "checkbox",
          id: "checkbox",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((isLoan).value = $event))
        }, null, 512), [
          [_vModelCheckbox, isLoan.value]
        ])
      ]),
      (isLoan.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("form", {
              class: "form-container flex-row-centered",
              onSubmit: _withModifiers(submit, ["prevent"])
            }, [
              _hoisted_5,
              _createVNode(PeriodSelector, {
                required: "",
                id: "periodSelector",
                hasNullSelector: "",
                nullSelectorName: "",
                modelValue: loanPeriod.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((loanPeriod).value = $event))
              }, null, 8, ["modelValue"]),
              _hoisted_6,
              _createVNode(CurrencyInput, {
                id: "vat-loan-amount",
                modelValue: loanAmount.value,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((loanAmount).value = $event)),
                min: 0.01,
                title: "The Vat Loan amount",
                required: ""
              }, null, 8, ["modelValue"]),
              _createElementVNode("button", {
                type: "submit",
                class: "default-btn",
                title: submitHint
              }, " Add ")
            ], 40, _hoisted_4),
            _createVNode(TablePersistentChecking, {
              Rows: rows.value,
              Cols: cols,
              Labels: labels
            }, null, 8, ["Rows"])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "submit",
          class: "default-btn",
          disabled: working.value,
          onClick: ConfirmDrawdown,
          title: workingReason.value
        }, " Confirm ", 8, _hoisted_7)
      ])
    ]),
    _: 1
  }, 8, ["model-value"]))
}
}

})